/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/hooks/useInteractiveEducationProps.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */
import { useGenerateAsyncQuizMe } from './useGenerateAsyncQuizMe.migrated';
import { useGenerateAsyncSummarization } from './useGenerateAsyncSummarization.migrated';
import { useGenerateAsyncIndustryUseCase } from './useGenerateAsyncIndustryUseCase.migrated';
export const useInteractiveEducationProps = ({
  primaryContentId,
  contentType,
  lessonContentId,
  videoId,
  contentPortalId,
  interactiveContentTrackingProps
}) => {
  const {
    onAsyncRegenerateQuiz,
    generateQuizError,
    generateQuizLoading
  } = useGenerateAsyncQuizMe({
    primaryContentId,
    contentType,
    interactiveContentTrackingProps
  });
  const {
    summary,
    correlationId: summaryCorrelationId,
    summaryError,
    summaryLoading,
    refetchSummary,
    videoDuration
  } = useGenerateAsyncSummarization({
    primaryContentId,
    contentType,
    lessonContentId
  });
  const {
    activeIndustry,
    useCase,
    correlationId: useCaseCorrelationId,
    useCaseError,
    useCaseLoading,
    refetchUseCase,
    generateForIndustry
  } = useGenerateAsyncIndustryUseCase({
    primaryContentId,
    contentType,
    contentPortalId,
    videoId
  });
  return {
    handleTriggerAsyncQuizGeneration: onAsyncRegenerateQuiz,
    generateQuizError: !!generateQuizError,
    generateQuizLoading,
    summary,
    summaryCorrelationId,
    summaryError,
    summaryLoading,
    refetchSummary,
    videoDuration: videoDuration !== null && videoDuration !== void 0 ? videoDuration : undefined,
    activeIndustry: typeof activeIndustry === 'string' ? activeIndustry : undefined,
    useCase,
    useCaseCorrelationId,
    useCaseError,
    useCaseLoading,
    refetchUseCase,
    generateForIndustry
  };
};